import brandConfig from '../../config'
import quoteAndBuyFormValidation from '../../../../form/shared/qb/validation'

export default quoteAndBuyFormValidation(brandConfig)
